/**
 * UAT environment configuration.
 *
 * @remarks
 * Uses an absolute API URL because Amplify Hosting is a static CDN —
 * there is no server-side proxy to forward relative /api/* paths.
 * Secrets are injected at build time via Angular's --define flag (esbuild).
 * The typeof guard means the build still succeeds without --define (CryptoService
 * will throw a clear error at the point of use if the key is missing).
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const __CRYPTO_KEY__: any;
declare const __MAPS_KEY__: any;
declare const __PRINT_PACKET_DELIVERY_TYPE__: any;

export const environment = {
  production: false,
  apiUrl: 'https://capi-uat.titaniumlegal.com/api/v2',
  mock: false,
  CRYPTOJSKEY: typeof __CRYPTO_KEY__ !== 'undefined' ? __CRYPTO_KEY__ : '',
  googleMapsApiKey: typeof __MAPS_KEY__ !== 'undefined' ? __MAPS_KEY__ : '',
  /** Sentry DSN — set this to your project DSN before deploying. Empty string disables Sentry. */
  sentryDsn: 'https://215e6517d0d7a5574cd033ef1900fa80@o4503977435529216.ingest.us.sentry.io/4511570469519360',
  /** Client firm IDs whose process servers see the Married? / Military? fields in the attempt-log form. */
  showMarriedMilitaryClientIds: [948],
  /** App Store IDs for version update feature. */
  iosAppId: '6474201206',
  androidPackage: 'com.titaniumlegal.serverapp',
  /**
   * TEST-ONLY debug override for how the Print Queue delivers a packet —
   * see {@link PrintService.deliveryChannels}. Sourced from the AWS Amplify
   * Console environment variable `PRINT_PACKET_DELIVERY_TYPE`, injected at build
   * time the same way `CRYPTOJSKEY`/`googleMapsApiKey` are (Angular's
   * `--define` flag — see "Build-time secrets & Sentry" in CLAUDE.md).
   *
   * @remarks
   * `'auto'` (the value every shipped build must use, and the default when
   * the Amplify env var is unset or empty) keeps production behaviour:
   * native (iOS/Android) POSTs to `/documents/email`, web/PWA POSTs to
   * `/documents/download`.
   *
   * The other three exist because each real path is otherwise unreachable
   * from the wrong platform — `Capacitor.isNativePlatform()` is always
   * `false` in a browser, so the email flow could not be exercised at all
   * without producing a native build first:
   * - `'download'` — force the download path, even on a native build.
   * - `'email'` — force the email path, even in a browser.
   * - `'download-and-email'` — call BOTH endpoints for one print action, so a single
   *                  tap tests the email queue and the file download together
   *                  (the UI still shows download-only screens — see
   *                  {@link PrintService.usesEmailDelivery}).
   *
   * Set the Amplify env var back to unset/`'auto'` when finished testing.
   */
  printPacketDeliveryType: typeof __PRINT_PACKET_DELIVERY_TYPE__ !== 'undefined' && __PRINT_PACKET_DELIVERY_TYPE__
    ? __PRINT_PACKET_DELIVERY_TYPE__
    : 'auto',
};
